import type { TourDefinition } from '../../../models/tour.interfaces';

export const employeesTour: TourDefinition = {
  module: 'employees',
  steps: [
    {
      id: 'mi_equipo_step_1',
      order: 1,
      target: '[data-testid="btn-add-employee"]',
      title: 'Agrega tu primer empleado',
      body: 'Haz clic aquí para registrar a tu primer colaborador en Prikly.',
      requiredAction: 'click',
      nextStepTrigger: 'onElementClick',
      placement: 'bottom',
      skippable: true,
    },
    {
      id: 'mi_equipo_step_2',
      order: 2,
      target: '[data-testid="form-employee"]',
      title: 'Completa los datos esenciales',
      body: 'Ingresa número de documento (8 dígitos para DNI y se autocompletará), nombre, apellido, correo electrónico y selecciona un rol.',
      completedBody: '¡Perfecto! Datos completos. Presiona el botón "Guardar empleado" para registrarlo.',
      requiredAction: 'fill',
      nextStepTrigger: 'onNextButton',
      placement: 'right',
      skippable: false,
      completionCheck: (el) => {
        const inputs = el.querySelectorAll('input');
        let document = '';
        let name = '';
        let lastName = '';
        let email = '';

        inputs.forEach((input: Element) => {
          const inp = input as HTMLInputElement;
          const inputName = inp.name || inp.getAttribute('name') || '';
          if (inputName === 'document') document = inp.value.trim();
          if (inputName === 'name') name = inp.value.trim();
          if (inputName === 'lastName') lastName = inp.value.trim();
          if (inputName === 'email') email = inp.value.trim();
        });

        // Check rol has a value (custom select renders as hidden input)
        const rolInput = el.querySelector('input[name="rol"]') as HTMLInputElement;
        const hasRol = rolInput ? rolInput.value.trim().length > 0 : false;

        const hasDocument = document.length >= 8;
        const hasName = name.length >= 3;
        const hasLastName = lastName.length >= 3;
        const hasEmail = /^[\w.%+-]+@[\w-]+\.[\w]{2,}$/i.test(email);

        return hasDocument && hasName && hasLastName && hasEmail && hasRol;
      },
    },
    {
      id: 'mi_equipo_step_3',
      order: 3,
      target: '[data-testid="employee-list"]',
      title: '¡Empleado registrado!',
      body: 'Tu primer empleado ha sido registrado. Puedes agregar más cuando lo necesites.',
      requiredAction: 'none',
      nextStepTrigger: 'onFinish',
      placement: 'top',
      skippable: true,
    },
  ],
};
